<template>
  <div class="navBar flex">
    <div class="cube flex" v-for="(item, index) in listBat" :key="index">
      <div class="circle_one">
        <img :src="item.pic" />
      </div>
      <div>
        <span>{{ item.name }}</span>
        <div class="valueNum">
          <span class="num">{{ item.value }}</span>
          <span class="ys" v-if="item.unit">({{ item.unit }})</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getScreenV2Hometbzb } from "@/api/home";
export default {
  data() {
    return {
      navList: [],
      list: [],
      xzIndex: 0,
      listBat: [
        {
          name: "项目总数",
          pic: require("images/index/nav/jsxm/项目总数.png"),
          value: 17,
          unit: ""
        },
        {
          name: "资金总投入",
          pic: require("images/index/nav/jsxm/资金总投入.png"),
          value: 51024.77,
          unit: "万元"
        },
        {
          name: "开工率",
          pic: require("images/index/nav/jsxm/开工率.png"),
          value: 32,
          unit: "%"
        },
        {
          name: "建设进度",
          pic: require("images/index/nav/jsxm/建设进度.png"),
          value: 72.04,
          unit: "%"
        },
        {
          name: "完工率",
          pic: require("images/index/nav/jsxm/完成率.png"),
          value: 30,
          unit: "%"
        }
      ]
    };
  },
  mounted() {
    // this.getData();
  },
  methods: {
    getData() {
      getScreenV2Hometbzb().then(res => {
        this.listBat = res.data;
        this.listBat[0].value = this.listBat[0].value / 10000;
        // this.listBat[0].unit = "万亩";
        // this.listBat[3].value = 69.47;
        this.listBat[0].pic = require("images/index/nav/h_ghmj.png");
        this.listBat[1].pic = require("images/index/nav/h_sszt.png");
        this.listBat[2].pic = require("images/index/nav/h_zjtr.png");
        this.listBat[3].pic = require("images/index/nav/h_jsjd.png");
        this.listBat[4].pic = require("images/index/nav/h_lndn.png");
      });
    },
    cubeClick() {}
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.navBar
  position absolute
  color #fff
  right calc(27% - 10px)
  left calc(27% - 10px)
  z-index 1
  top 105px
  justify-content space-around
  font-size .06rem
  height .35rem

.cube
  background url('~images/index/nav/navBg.png') center no-repeat
  background-size 100% 100%
  height 100%
  justify-content center
  width 18%
  opacity .9
  // cursor pointer

.valueNum
  color $textColor
.xzBar
  background rgba(11,46,42,0.8)
  box-shadow inset 0px 0px 0.06rem #0ff
.num
  font-size .15rem

.circle_one
  position relative
  margin-right .05rem

  img
    width .25rem
    height .25rem
    vertical-align middle
</style>
